<template>
  <div>
    <div class="content" id='portal-index'>
      <!--Banner-->
      <div class="banner">
        <div class="banner-search">
          <div>
            <div class="search-item">
              <div>
                <el-input
                  placeholder="想居住在哪个小区？"
                  v-model="keyword"
                  class="input-with-select"
                  type="text"
                >
                  <el-button
                    slot="suffix"
                    class="search"
                    icon="el-icon-search"
                    @click="search"
                    type="primary"
                  >找房</el-button>
                  <el-button
                    slot="append"
                    class="mapSearch"
                    type="primary"
                    icon="el-icon-location-information"
                    @click="mapSearch"
                  >地图找房</el-button>
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <el-carousel class="banner-imgs" :interval="8000">
          <el-carousel-item v-for="(bannerImg, index) in bannerList" :key="index">
            <a :href="bannerImg.urlAddr">
              <img :src="bannerImg.url" style="width:100%;height:100%;" />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--热门房源-->
      <div class="hot-housing">
        <div class="hot-title">
           <div class="title-left">
             热门房源
             <!-- <div class="div-panel-bottom"></div> -->
           </div>
           <div class="title-right">
             <a @click="getMore(4)">查看更多 ></a>
           </div>
        </div>
        <div class="hot-content">
          <el-row>
            <el-col :span="8" v-for="(housing, index) in hotHousingList" :key="index" :offset="index > 0 ? 1 : 0">
              <el-card :body-style="{ padding: '0px' }" shadow="hover" @click.native="gotoDetail(housing.id)">
                <div class="hot-img">
                  <!-- <img :src=housing.cover style="width:370px; height:278px;"> -->
                  <el-image :src=housing.cover style="width: 370px; height: 278px">
                      <div slot="error" class="image-slot">
                          <img :src="require('@/assets/imgs/pic.jpg')" style="width: 370px; height: 278px">
                      </div>
                  </el-image>
                </div>
                
                <div class="hot-desc">
                  <div class="hot-housing-intro">
                    <div class="community-name" :title="housing.name">
                      {{housing.name}}
                    </div>
                    <!-- <div class="housing-price">
                      ￥{{housing.rental}}元起/月
                    </div> -->
                  </div>
                  <div class="hot-housing-addr">
                    <img :src="require('@/assets/imgs/position-smaill.png')" />
                    &nbsp;{{housing.address}}
                  </div>
                  <div class="hot-housing-props">
                      <el-row>
                        <el-col :span="4" v-for="(prop , pindex) in housing.props" :key="pindex" :offset="pindex > 0 ? 1: 0">
                          <el-tag>{{prop}}</el-tag>
                        </el-col>
                      </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--即将上线房源-->
      <div class="coming-housing" v-if="comingHousingList && comingHousingList.length > 0">
        <div class="coming-title">
           <div class="title-left">
             即将上线
             <!-- <div class="div-panel-bottom"></div> -->
           </div>
           <div class="title-right">
             <a @click="getMore(5)">查看更多 ></a>
           </div>
        </div>
        <div class="coming-content">
          <el-row>
            <el-col :span="8" v-for="(housing, index) in comingHousingList" :key="index" :offset="index > 0 ? 1 : 0">
              <el-card :body-style="{ padding: '0px' }" shadow="hover" @click.native="gotoDetail(housing.id)">
                <div class="coming-img">
                  <el-image :src=housing.cover style="width: 370px; height: 278px">
                    <div slot="error" class="image-slot">
                        <img :src="require('@/assets/imgs/pic.jpg')" style="width: 370px; height: 278px">
                    </div>
                  </el-image>
                </div>
                
                <div class="coming-desc">
                  <div class="coming-housing-intro">
                    <div class="community-name">
                      {{housing.name}}
                    </div>
                    <!-- <div class="housing-price">
                      ￥{{housing.rental}}元起/月
                    </div> -->
                  </div>
                  <div class="coming-housing-addr">
                    <i class="el-icon-location-information"></i>
                    &nbsp;{{housing.address}}
                  </div>
                  <div class="coming-housing-props">
                      <el-row>
                        <el-col :span="4" v-for="(prop , pindex) in housing.props" :key="pindex" :offset="pindex > 0 ? 1: 0">
                          <el-tag>{{prop}}</el-tag>
                        </el-col>
                      </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--新闻及申请入口-->
      <div class="news">
        <!--新闻中心-->
        <div class="news-center">
          <div class="news-list">   
            <div class="news-tab">
                <div class="news-title">
                  新闻动态
                </div>
                <div class="news-more">
                  <a @click="jumpMoreNews(0)">更多></a>
                </div>
            </div>
            <div class="news-item">
                <ul>
                  <li v-for="news in newsList" :key="news.id"
                    @click="gotoNews(news.id)">
                      {{news.title}}
                  </li>
                </ul>
            </div>
          </div>
          <div class="news-list">
            <div class="news-tab">
                <div class="news-title">
                  党建园地
                </div>
                <div class="news-more">
                  <a @click="jumpMoreNews(1)">更多></a>
                </div>
            </div>
            <div class="news-item">
                <ul>
                  <li v-for="news in partyList" :key="news.id"
                    @click="gotoNews(news.id)">
                      {{news.title}}
                  </li>
                </ul>
            </div>          
          </div>
        </div>
        <!--申请入口-->
        <div class="apply-nav">
          <div class="apply-item" @click="gotoCompanyApply()">
            <img :src="require('@/assets/imgs/ico-apply-1.png')" />
            <span>单位住房申请</span>
          </div>
          <div class="apply-item" @click="gotoPersonalApply()">
            <img :src="require('@/assets/imgs/ico-apply-2.png')" />
            <span>个人住房申请</span>
          </div>
          <div class="apply-item" @click="gotoManageAdmin()">
            <img :src="require('@/assets/imgs/ico-apply-1.png')" />
            <span>候租人数查询</span>
          </div>
        </div>
      </div>
    </div>
    <Login v-if="dialogVisibleLogin" ref="login"></Login>
    <Register v-if="dialogVisibleRegister" ref="register"></Register>
    <QueryWaitingNum v-if="dialogVisbleQuery" ref="queryNum"></QueryWaitingNum>
  </div>
</template>

<script>
import "../../assets/css/portalIndex.less";
import PortalApi from "@/api/portal/index";
import { getUserInfo, removeUserInfo } from "@/store/index";
import Register from "../../components/login/Register";
import Login from "../../components/login/Login";
import QueryWaitingNum from "./QueryWaitingNum";
export default {
  data() {
    return {
      // 下面的数组数据均为测试数据
      // 实际需要通过api去调用（方法在methods里面定义）
      dialogVisibleRegister: false,
      dialogVisibleLogin: false,
      dialogVisbleQuery : false,
      UserInfo: {},
      keyword: "",
      select: "",
      bannerList: [
        {
          url: require("@/assets/imgs/banner.png"),
          urlAddr: "#",
        },
        // {
        //   url: require("@/assets/imgs/banner_2.png"),
        //   urlAddr: "#",
        // },
      ],
      hotHousingList:[],
      comingHousingList:[],
      newsList:[],
      partyList:[],      
    };
  },
  components: { Register, Login, QueryWaitingNum },
  methods: {
    // 获取banner图片
    gerBannerImgs() {
      PortalApi.getBannerImgs()
        .then(
          (res) => {
            this.bannerList = res.data;
            if (this.bannerList.length === 0) {
              this.bannerList.push(require("@/assets/imgs/banner.jpg"));
              this.bannerList.push(require("@/assets/imgs/banner_2.png"));
            }
          },
          (err) => {
            this.$message({
              message: err,
              center: true,
            });
          }
        )
        .catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    // 重置用户信息
    resetUserInfo() {
      removeUserInfo();
      getUserInfo().then((data) => {
        this.UserInfo = data;
      });
    },
    // 地图选房
    mapSearch() {
      this.$router.push({ path: "/MapSearch" });
    },
    // 新闻详情
    gotoNews(id) {
      this.$router.push({ path: "NewsDetail", query: { menu:"新闻资讯", name:"新闻动态",type:0, id: id} })
    },
    jumpMoreNews(tab){
      if(tab == 0){
        this.$router.push({ path: "News", query: { name: "新闻动态",type:1,id:2 } });
      }
      else{
        this.$router.push({ path: "ContactUs", query: { name: "党建园地",type:1,id:1 } });
      }
    },
    // 获取热门房源信息
    getHotHousingList() {
      var obj = [{id:"",type:"4",name:""}]
      PortalApi.getCommunityList(1,3,obj)
        .then(
          (res) => {
            this.hotHousingList = res.data;
          },
          (err) => {
            this.$message({
              message: err,
              center: true,
            });
          }
        )
        .catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    // 获取即将发布房源信息
    getCommingHousingList() {
      var obj = [{id:"",type:"5",name:""}]
      PortalApi.getCommunityList(1,3,obj)
        .then(
          (res) => {
            this.comingHousingList = res.data;
          },
          (err) => {
            this.$message({
              message: err,
              center: true,
            });
          }
        )
        .catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    // 更多信息
    getMore(type) {
      this.$router.push({
        path: "/HouseList",
        query: { type: type },
      });
    },
    // 点击搜索按钮
    search() {
      this.$router.push({
        path: "/HouseList",
        query: { keyword: this.keyword },
      });
    },    
    // 获取党园新闻
    getPartyList() {
      PortalApi.getArticleListBySubmoduletype(1, 1, 0, 6).then((res) =>{
        this.partyList = res.data;
      },
      (err)=>{
        this.$message({
              message: err,
              center: true,
            });
      }).catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    // 获取公司新闻
    getNewsList(){
      PortalApi.getArticleListBySubmoduletype(1, 2, 0, 6).then((res) =>{
        this.newsList = res.data;
      },
      (err)=>{
        this.$message({
              message: err,
              center: true,
            });
      }).catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    // 个人申请
    gotoPersonalApply() {      
      if (!this.UserInfo || !this.UserInfo.name) {
        this.dialogVisibleLogin = true;
        this.$nextTick(() => {
          this.$refs.login.dialogVisible = true;
        });
      } else {
        //登录后判断用户有没有进行过申请
        PortalApi.judgeUserHasApplied()
        .then(
            res=>{
                if(res.data==false){
                    this.$router.push({ path: "/Apply" });
                }else{
                  this.$router.push({ path: "/User" });
                }
            }
        )
      }
    },
    // 单位申请
    gotoCompanyApply() {
      window.open("http://rent.jdgzf.net/");
    },
    // 进度查询
    gotoManageAdmin() {
      //this.$router.push({ path: "/HouseList"});
      this.dialogVisbleQuery = true;
      this.$nextTick(() => {
        this.$refs.queryNum.dialogVisible = true;
      });
    },
    // 单个房源点击进入房源详情
    gotoDetail(id) {
      const routeUrl = this.$router.resolve({
          path: "/HouseDetail",
          query: { id: id },
          });
      window.open(routeUrl.href, "_blank");
      //this.$router.push({ path: "/HouseDetail", query: { id: id } });
    },
    // 搜索框底下的小字
    /* choose(name) {
      // this.keyword = name
      this.$router.push({
        path: "/HouseList",
        query: { keyword: name, select: this.select },
      });
    }, */
    // 切换新闻卡片，左侧图片自动变换
    swicthCard(index) {
      this.$refs.carousel.setActiveItem(index);
    },
  },
  beforeCreate: function(){
    localStorage.setItem("checkedIndex", 1);
  },
  mounted: function () {
    this.getNewsList();
    this.getPartyList();
    this.getHotHousingList();
    this.getCommingHousingList();
    //this.getThreeRoomList();
    //this.getCommunityList();
    //this.getsStreetTownList();
    //this.gerBannerImgs();
    //this.resetUserInfo();
    getUserInfo().then((data) => {
      this.UserInfo = data;
    });
  },
  activated: function () {
    this.keyword = "";
    this.select = "";
    //this.getThreeRoomList();
    //this.getCommunityList();
    //this.getsStreetTownList();
    //this.gerBannerImgs();
    //this.resetUserInfo();
    //getUserInfo().then((data) => {
    //  this.UserInfo = data;
    //});
  },
};
</script>

<style>
.content {
  margin-top: 146px;
}
</style>